export default __webpack_public_path__ + "static/media/allgemein_9.3a8aa6a5.jpg";